export default __webpack_public_path__ + "static/media/autpco.bcc67f38.png";